export const getNumericIdFromUrl = (pathname) => {
  const match = pathname.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
};